import { Component, input } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { CommonIconsComponent } from '@shared/icon-components/common-icons.component';
import { common_icons_ids } from '@shared/icon-components/common-icons.ids';
import { loading_toaster_default_strings } from '@shared/components/loading-toaster/strings/default-strings';

type CommonIconId = (typeof common_icons_ids)[keyof typeof common_icons_ids];

@Component({
  selector: 'app-loading-toaster',
  templateUrl: './loading-toaster.component.html',
  styleUrls: ['./loading-toaster.component.scss'],
  imports: [ToastModule, ProgressBarModule, CommonIconsComponent],
})
export class LoadingToasterComponent {
  /**
   * Icon rendered before the toast summary text.
   * Defaults to the existing error icon to preserve current behavior.
   */
  iconType = input<CommonIconId>(loading_toaster_default_strings.iconType);
}
